var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsumerPromoBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 860,
    height: 480,
    viewBox: "0 0 860 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M-189.499 14.4918C-185.383 7.59399 -178.518 -1.44258 -112.159 -54.2839C-51.3654 -102.693 67.7997 -190.709 130.831 -237.56C193.862 -284.41 197.995 -286.346 200.839 -285.721C203.684 -285.097 205.115 -281.854 204.573 -276.818C204.031 -271.782 201.471 -265.051 147.098 -179.951C92.7248 -94.8507 -13.385 68.4147 -66.8987 150.864C-120.412 233.314 -118.114 230 -107.581 220.374C-97.048 210.748 -78.3492 194.909 19.596 138.849C117.541 82.7881 294.166 -13.0144 396.175 -66.5276C498.183 -120.041 520.223 -128.362 533.268 -133.012C546.312 -137.663 549.693 -138.391 550.888 -136.67C552.083 -134.949 550.989 -130.756 480.208 -36.7909C409.427 57.1739 268.992 240.783 193.431 340.965C117.869 441.147 111.438 452.338 109.331 456.417C108.978 457.101 119.726 446.921 207.502 395.496C286.702 349.096 440.187 268.338 551.512 213.698C662.836 159.057 728.351 134.736 762.864 123.6C797.377 112.465 798.903 115.252 799.162 118.198C800.32 131.405 786.925 140.31 748.22 196.584C711.6 249.827 642.511 354.555 605.825 410.607C569.139 466.659 567.462 471.21 585.215 460.142C602.968 449.074 640.202 422.249 690.845 392.462C741.487 362.675 804.41 330.739 846.672 311.196C888.934 291.654 908.628 285.473 920.525 282.075C932.422 278.677 935.926 278.248 939.535 277.806",
    stroke: "white",
    strokeWidth: 100,
    strokeLinecap: "square",
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumerPromoBg);
export default __webpack_public_path__ + "static/media/consumer-promo-bg.7383b051ae29d9a8c5776c04ffa2ff9a.svg";
export { ForwardRef as ReactComponent };